

export interface ICustomHoliday {
  customHolidayID: number;
  name: string;
  date: string;
  everyYear: boolean;
  description: string;
  editData: ICustomHoliday | null;
  validItem: any;
  isEdit(): boolean;
}


export class CCustomHoliday implements ICustomHoliday {
  public customHolidayID = 0;
  public name = '';
  public date = todayString();
  public description = '';
  public everyYear = false;
  public editData = null;
  public validItem = null;

  public isEdit = (): boolean => this.editData !== null && !isEqual(this, this.editData);
}

// カレンダー表示用
export interface ICustomHolidayView {
  customHolidayID: number;
  name: string;
  date: string;
  everyYear: boolean;
  description: string;
}

const todayString = (): string => {
  const now = new Date();
  return now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate();
};

const isEqual = (src: ICustomHoliday, comp: ICustomHoliday|null): boolean => {
  return comp !== null
    && src.name === comp.name
    && src.date === comp.date
    && src.everyYear === comp.everyYear;
};
